import { RefObject } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FileUploadManager, {
  FileUploadManagerRef,
} from "../../../../components/forms/fileUploadManager";
import FloatingField from "../ui/FloatingField";
import FloatingTextArea from "../ui/FloatingTextArea";
import { TwoPartyContractInputs } from "../schema";
import styles from "../styles.module.scss";

interface IStepDetailsProps {
  fileUploadRef: RefObject<FileUploadManagerRef>;
  onUploadStatusChange: (isUploading: boolean) => void;
}

/** Step one: title, description and attachments. */
const StepDetails = ({
  fileUploadRef,
  onUploadStatusChange,
}: IStepDetailsProps) => {
  const { t } = useTranslation();
  const {
    control,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext<TwoPartyContractInputs>();

  return (
    <div className={styles.fields}>
      <Controller
        name="title"
        control={control}
        render={({ field }) => (
          <FloatingField
            {...field}
            maxLength={100}
            label={t("lbl_transaction_title")}
            hint={t("lbl_title_max_100_chars")}
            errorMessage={errors?.title?.message?.toString()}
          />
        )}
      />
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <FloatingTextArea
            {...field}
            maxLength={2000}
            label={t("lbl_description")}
            errorMessage={errors?.description?.message?.toString()}
          />
        )}
      />
      {/* The shared uploader brings its own "Attachments" heading and size hint. */}
      <div className={styles.attachments}>
        <FileUploadManager
          ref={fileUploadRef}
          validateFiles
          initialFiles={getValues("files")}
          onFilesChange={(files) =>
            setValue("files", files, { shouldDirty: true })
          }
          onUploadStatusChange={onUploadStatusChange}
        />
      </div>
    </div>
  );
};

export default StepDetails;
